// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"menuIcon_menuIcon__3Edk0"};